module.exports = __webpack_public_path__ + "static/media/LOGOMM.653bd0d7.png";